import { useState, useEffect } from "react";
import { useComparisonModals } from "./ComparisonModalManager";
import { UnitInfoDialog } from "./UnitInfoDialog";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

// Hook to detect if we're on mobile (< lg breakpoint = 1024px)
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < 1024;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}

export function ComparisonModalWrapper() {
  const { modals, closeComparisonModal, closeAllComparisonModals } = useComparisonModals();
  const isMobile = useIsMobile();

  // Don't render on mobile
  if (isMobile || modals.length === 0) {
    return null;
  }

  return (
    <>
      {/* Render all comparison modals */}
      {modals.map((modal) => (
        <UnitInfoDialog
          key={modal.id}
          open={true}
          onOpenChange={() => closeComparisonModal(modal.id)}
          unit={modal.unit}
          comparisonMode={true}
          position={modal.position}
          id={modal.id}
          onClose={() => closeComparisonModal(modal.id)}
        />
      ))}

      {/* Close All button - shown when 2+ modals are open */}
      {modals.length >= 2 && (
        <div className="fixed top-4 right-4 z-[200]">
          <Button
            onClick={closeAllComparisonModals}
            variant="secondary"
            size="sm"
            className="shadow-lg"
            aria-label="Close all comparison modals"
          >
            <X className="h-4 w-4 mr-2" />
            Close All ({modals.length})
          </Button>
        </div>
      )}
    </>
  );
}
